'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require('bluebird');

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _languageHandler = require('../../../languageHandler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PHASE_START = 0; /*
                     Copyright 2019 New Vector Ltd
                     
                     Licensed under the Apache License, Version 2.0 (the "License");
                     you may not use this file except in compliance with the License.
                     You may obtain a copy of the License at
                     
                         http://www.apache.org/licenses/LICENSE-2.0
                     
                     Unless required by applicable law or agreed to in writing, software
                     distributed under the License is distributed on an "AS IS" BASIS,
                     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                     See the License for the specific language governing permissions and
                     limitations under the License.
                     */

var PHASE_SHOW_SAS = 1;
var PHASE_WAIT_FOR_PARTNER_TO_CONFIRM = 2;
var PHASE_VERIFIED = 3;
var PHASE_CANCELLED = 4;

var IncomingSasDialog = function (_React$Component) {
    (0, _inherits3.default)(IncomingSasDialog, _React$Component);

    function IncomingSasDialog(props) {
        (0, _classCallCheck3.default)(this, IncomingSasDialog);

        var _this = (0, _possibleConstructorReturn3.default)(this, (IncomingSasDialog.__proto__ || (0, _getPrototypeOf2.default)(IncomingSasDialog)).call(this, props));

        _this._onFinished = function () {
            _this.props.onFinished(_this.state.phase === PHASE_VERIFIED);
        };

        _this._onCancelClick = function () {
            _this.props.onFinished(_this.state.phase === PHASE_VERIFIED);
        };

        _this._onContinueClick = function () {
            _this.setState({ phase: PHASE_WAIT_FOR_PARTNER_TO_CONFIRM });
            _this.props.verifier.verify().then(function () {
                _this.setState({ phase: PHASE_VERIFIED });
            }).catch(function (e) {
                console.log("Verification failed", e);
            });
        };

        _this._onVerifierShowSas = function (e) {
            _this._showSasEvent = e;
            _this.setState({
                phase: PHASE_SHOW_SAS,
                sas: e.sas
            });
        };

        _this._onVerifierCancel = function (e) {
            _this.setState({
                phase: PHASE_CANCELLED
            });
        };

        _this._onSasMatchesClick = function () {
            _this._showSasEvent.confirm();
            _this.setState({
                phase: PHASE_WAIT_FOR_PARTNER_TO_CONFIRM
            });
        };

        _this._onVerifiedDoneClick = function () {
            _this.props.onFinished(true);
        };

        var phase = PHASE_START;
        if (_this.props.verifier.cancelled) {
            console.log("Verifier was cancelled in the background.");
            phase = PHASE_CANCELLED;
        }

        _this._showSasEvent = null;
        _this.state = {
            phase: phase,
            sasVerified: false,
            opponentProfile: null,
            opponentProfileError: null
        };
        _this.props.verifier.on('show_sas', _this._onVerifierShowSas);
        _this.props.verifier.on('cancel', _this._onVerifierCancel);
        _this._fetchOpponentProfile();
        return _this;
    }

    (0, _createClass3.default)(IncomingSasDialog, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.state.phase !== PHASE_CANCELLED && this.state.phase !== PHASE_VERIFIED) {
                this.props.verifier.cancel('User cancel');
            }
            this.props.verifier.removeListener('show_sas', this._onVerifierShowSas);
        }
    }, {
        key: '_fetchOpponentProfile',
        value: function () {
            var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var prof;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return (0, _bluebird.resolve)(_MatrixClientPeg2.default.get().getProfileInfo(this.props.verifier.userId));

                            case 3:
                                prof = _context.sent;

                                this.setState({
                                    opponentProfile: prof
                                });
                                _context.next = 10;
                                break;

                            case 7:
                                _context.prev = 7;
                                _context.t0 = _context['catch'](0);

                                this.setState({
                                    opponentProfileError: _context.t0
                                });

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 7]]);
            }));

            function _fetchOpponentProfile() {
                return _ref.apply(this, arguments);
            }

            return _fetchOpponentProfile;
        }()
    }, {
        key: '_renderPhaseStart',
        value: function _renderPhaseStart() {
            var DialogButtons = _index2.default.getComponent('views.elements.DialogButtons');
            var Spinner = _index2.default.getComponent("views.elements.Spinner");
            var BaseAvatar = _index2.default.getComponent("avatars.BaseAvatar");

            var profile = void 0;
            if (this.state.opponentProfile) {
                profile = _react2.default.createElement(
                    'div',
                    { className: 'mx_IncomingSasDialog_opponentProfile' },
                    _react2.default.createElement(BaseAvatar, { name: this.state.opponentProfile.displayname,
                        idName: this.props.verifier.userId,
                        url: _MatrixClientPeg2.default.get().mxcUrlToHttp(this.state.opponentProfile.avatar_url, Math.floor(48 * window.devicePixelRatio), Math.floor(48 * window.devicePixelRatio), 'crop'),
                        width: 48, height: 48, resizeMethod: 'crop'
                    }),
                    _react2.default.createElement(
                        'h2',
                        null,
                        this.state.opponentProfile.displayname
                    )
                );
            } else if (this.state.opponentProfileError) {
                profile = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(BaseAvatar, { name: this.props.verifier.userId.slice(1),
                        idName: this.props.verifier.userId,
                        width: 48, height: 48
                    }),
                    _react2.default.createElement(
                        'h2',
                        null,
                        this.props.verifier.userId
                    )
                );
            } else {
                profile = _react2.default.createElement(Spinner, null);
            }

            return _react2.default.createElement(
                'div',
                null,
                profile,
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _languageHandler._t)("Verify this user to mark them as trusted. " + "Trusting users gives you extra peace of mind when using " + "end-to-end encrypted messages.")
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _languageHandler._t)(
                    // NB. Below wording adjusted to singular 'device' until we have
                    // cross-signing
                    "Verifying this user will mark their device as trusted, and " + "also mark your device as trusted to them.")
                ),
                _react2.default.createElement(DialogButtons, {
                    primaryButton: (0, _languageHandler._t)('Continue'),
                    hasCancel: true,
                    onPrimaryButtonClick: this._onContinueClick,
                    onCancel: this._onCancelClick
                })
            );
        }
    }, {
        key: '_renderPhaseShowSas',
        value: function _renderPhaseShowSas() {
            var VerificationShowSas = _index2.default.getComponent('views.verification.VerificationShowSas');
            return _react2.default.createElement(VerificationShowSas, {
                sas: this._showSasEvent.sas,
                onCancel: this._onCancelClick,
                onDone: this._onSasMatchesClick
            });
        }
    }, {
        key: '_renderPhaseWaitForPartnerToConfirm',
        value: function _renderPhaseWaitForPartnerToConfirm() {
            var Spinner = _index2.default.getComponent("views.elements.Spinner");

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(Spinner, null),
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _languageHandler._t)("Waiting for partner to confirm...")
                )
            );
        }
    }, {
        key: '_renderPhaseVerified',
        value: function _renderPhaseVerified() {
            var VerificationComplete = _index2.default.getComponent('views.verification.VerificationComplete');
            return _react2.default.createElement(VerificationComplete, { onDone: this._onVerifiedDoneClick });
        }
    }, {
        key: '_renderPhaseCancelled',
        value: function _renderPhaseCancelled() {
            var VerificationCancelled = _index2.default.getComponent('views.verification.VerificationCancelled');
            return _react2.default.createElement(VerificationCancelled, { onDone: this._onCancelClick });
        }
    }, {
        key: 'render',
        value: function render() {
            var body = void 0;
            switch (this.state.phase) {
                case PHASE_START:
                    body = this._renderPhaseStart();
                    break;
                case PHASE_SHOW_SAS:
                    body = this._renderPhaseShowSas();
                    break;
                case PHASE_WAIT_FOR_PARTNER_TO_CONFIRM:
                    body = this._renderPhaseWaitForPartnerToConfirm();
                    break;
                case PHASE_VERIFIED:
                    body = this._renderPhaseVerified();
                    break;
                case PHASE_CANCELLED:
                    body = this._renderPhaseCancelled();
                    break;
            }

            var BaseDialog = _index2.default.getComponent("dialogs.BaseDialog");
            return _react2.default.createElement(
                BaseDialog,
                {
                    title: (0, _languageHandler._t)("Incoming Verification Request"),
                    onFinished: this._onFinished
                },
                body
            );
        }
    }]);
    return IncomingSasDialog;
}(_react2.default.Component);

IncomingSasDialog.propTypes = {
    verifier: _propTypes2.default.object.isRequired
};
exports.default = IncomingSasDialog;
module.exports = exports['default'];
//# sourceMappingURL=IncomingSasDialog.js.map